import { MsalProvider } from '@azure/msal-react'
import i18n, { initializeI18N } from '@if/core/i18n'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './containers/App/App'
import './index.css'
import initializeAppInsights from './services/AppInsights'
import { handleB2CForgotPassword, isB2CCancelled, initializeMsal } from './services/Authentification'
import { reportErrorToConsole, setupTracking } from './services/error-logger'

const ai = initializeAppInsights()
setupTracking(ai)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

const container = document.getElementById('root')
const root = createRoot(container!)
const msalInstance = initializeMsal()

if (!handleB2CForgotPassword()) {
  Promise.all([initializeI18N(), msalInstance.initialize().catch((error) => {
    // On cancel, swallow the MSAL error so the app renders and /auth-page navigates to base URL.
    if (!isB2CCancelled()) console.warn('MSAL initialization error:', error)
  })])
    .then(() => {
      root.render(
      <Suspense fallback="loading">
        <I18nextProvider i18n={i18n}>
          <MsalProvider instance={msalInstance}>
            <QueryClientProvider client={queryClient}>
              <App />
              <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
            </QueryClientProvider>
          </MsalProvider>
        </I18nextProvider>
      </Suspense>,
    )
  })
  .catch(reportErrorToConsole)
}
